import row from './row'

export default {
    mixins: [row],

    props: {
        activities: {
            type: Array,
            required: true,
            default: () => {
                return [];
            },
        },
    }
}